import { i18nFactory } from '@lib/i18n';
import type { Currency } from '@typings/api/IPublication';

const ru = {
    GE: 'Грузия',
    TBI: 'Тбилиси',
    BAT: 'Батуми',
    RUS: 'Рустави',
    KUT: 'Кутаиси',
    SUK: 'Сухум',
    GOR: 'Гори',
    POT: 'Поти',
    ZUG: 'Зугдиди',
    TSK: 'Цхинвал',
    MAR: 'Марнеули',
    KHA: 'Хашури',
    SAM: 'Самтредия',
    ZES: 'Зестафони',
    TEL: 'Телави',
    KOB: 'Кобулети',
    AKH: 'Ахалцихе',
    GAG: 'Гагра',
    SEN: 'Сенаки',
    OZU: 'Озургети',
    GAR: 'Гардабани',
    KAS: 'Каспи',
    CHI: 'Чиатура',
    BOR: 'Боржоми',
    KVA: 'Кварели',
    SAG: 'Сагареджо',
    BOL: 'Болниси',
    TKI: 'Ткибули',
    GUD: 'Гудаута',
    KHO: 'Хони',
    GAL: 'Гал',
    CHA: 'Чакви',
    AKHA: 'Ахалкалаки',
    DUS: 'Душети',
    MTS: 'Мцхета',
    GUR: 'Гурджаани',
    TSKA: 'Цхалтубо',
    SUR: 'Сурами',
    KAR: 'Карели',
    LAN: 'Ланчхути',
    AKHM: 'Ахмета',
    LAG: 'Лагодехи',
    KAZ: 'Казрети',
    DED: 'Дедоплисцкаро',
    OCH: 'Очамчыра',
    SAC: 'Сачхере',
    TET: 'Тетри-Цкаро',
    TQW: 'Ткуарчал',
    VAL: 'Вале',
    TER: 'Тержола',
    TSN: 'Цнори',
    ABA: 'Абаша',
    PIT: 'Пицунда',
    MART: 'Мартвили',
    GUL: 'Гулрыпш',
    TSA: 'Цалка',
    NIN: 'Ниноцминда',
    TIA: 'Тианети',
    VAN: 'Вани',
    DMA: 'Дманиси',
    KHOB: 'Хоби',
    TSAL: 'Цаленджиха',
    AGA: 'Агара',
    ZHI: 'Жинвали',
    ONI: 'Они',
    ASP: 'Аспиндза',
    BAG: 'Багдати',
    CHK: 'Чхороцку',
    JAV: 'Дзау',
    SHO: 'Шорапани',
    AMB: 'Амбролаури',
    BAK: 'Бакуриани',
    KHAR: 'Харагаули',
    MES: 'Местиа',
    MAN: 'Манглиси',
    URE: 'Уреки',
    STE: 'Степанцминда',
    NEW: 'Новый Афон',
    CHO: 'Чохатаури',
    SIG: 'Сигнахи',
    ANA: 'Анаклиа',
    JVA: 'Джвари',
    PAS: 'Пасанаури',
    ADI: 'Адигени',
    KED: 'Кеда',
    AKHAL: 'Ленингор',
    LEN: 'Лентехи',
    TSAG: 'Цагери',
    KVAI: 'Квайса',
    KHU: 'Хуло',
    ABAS: 'Абастумани',
    SHU: 'Шуахеви',
    bath: 'Ванна',
    shower: 'Душ',
    country: 'Страна',
    city: 'Город',
    street: 'Улица',
    houseNumber: 'Номер дома',
    typeApartment: 'Тип квартиры',
    notSelectType: 'Не выбрано',
    studio: 'Студия',
    apartment1room: '1-к квартира',
    apartment2room: '2-к квартира',
    apartment3room: '3-к квартира',
    apartment4room: '4-к квартира',
    house: 'Дом',
    address: 'Адрес',
    floor: 'Этаж',
    square: 'Площадь',
    price: 'Цена',
    heating: 'Центральное отопление',
    oven: 'Духовка',
    dishwasher: 'Посудомойка',
    balcony: 'Балкон',
    animal: 'Можно с животными',
    conditioner: 'Кондиционер',
    microwave: 'Микроволновка',
    perMonth: 'в месяц',
    submit: 'Отправить',
    description: 'Описание',
    priceTo: 'Цена ДО',
    priceFrom: 'Цена ОТ',
    squareFrom: 'Площадь ОТ',
    squareTo: 'Площадь ДО',
    floorFrom: 'Этаж ОТ',
    floorTo: 'Этаж ДО',
    sell: 'Продажа',
    rent: 'Аренда',
    needAuth: 'Для просмотра этой страницы необходимо авторизоваться!',
    conveniences: 'Удобства',
    toasterErrorTitle: 'Ошибка!',
    toasterSuccessTitle: 'Успешно!',
    location: 'Локация',
    linkCopied: 'Ссылка на объявление скопирована в буфер обмена.',
    unableSendMessage: 'Мы не смогли отправить Вам сообщение..',
    botSentMessage: 'Бот отправил Вам объявление',
};

const en = {
    GE: 'Georgia',
    TBI: 'Tbilisi',
    BAT: 'Batumi',
    RUS: 'Rustavi',
    KUT: 'Kutaisi',
    SUK: 'Sukhum',
    GOR: 'Gori',
    POT: 'Poti',
    ZUG: 'Zugdidi',
    TSK: 'Tskhinvali',
    MAR: 'Marneuli',
    KHA: 'Khashuri',
    SAM: 'Samtredia',
    ZES: 'Zestaponi',
    TEL: 'Telavi',
    KOB: 'Kobuleti',
    AKH: 'Akhaltsikhe',
    GAG: 'Gagra',
    SEN: 'Senaki',
    OZU: 'Ozurgeti',
    GAR: 'Gardabani',
    KAS: 'Kaspi',
    CHI: 'Chiatura',
    BOR: 'Borjomi',
    KVA: 'Kvareli',
    SAG: 'Sagarejo',
    BOL: 'Bolnisi',
    TKI: 'Tkibuli',
    GUD: 'Gudauta',
    KHO: 'Khoni',
    GAL: 'Gal',
    CHA: 'Chakvi',
    AKHA: 'Akhalkalaki',
    DUS: 'Dusheti',
    MTS: 'Mtskheta',
    GUR: 'Gurjaani',
    TSKA: 'Tskaltubo',
    SUR: 'Surami',
    KAR: 'Kareli',
    LAN: 'Lanchkhuti',
    AKHM: 'Akhmeta',
    LAG: 'Lagodekhi',
    KAZ: 'Kazreti',
    DED: 'Dedoplistskaro',
    OCH: 'Ochamchyra',
    SAC: 'Sachkhere',
    TET: 'Tetritskaro',
    TQW: 'Tqwarchal',
    VAL: 'Vale',
    TER: 'Terjola',
    TSN: 'Tsnori',
    ABA: 'Abasha',
    PIT: 'Pitsunda',
    MART: 'Martvili',
    GUL: 'Gulrypsh',
    TSA: 'Tsalka',
    NIN: 'Ninotsminda',
    TIA: 'Tianeti',
    VAN: 'Vani',
    DMA: 'Dmanisi',
    KHOB: 'Khobi',
    TSAL: 'Tsalenjikha',
    AGA: 'Agara',
    ZHI: 'Zhinvali',
    ONI: 'Oni',
    ASP: 'Aspindza',
    BAG: 'Baghdati',
    CHK: 'Chkhorotsku',
    JAV: 'Java',
    SHO: 'Shorapani',
    AMB: 'Ambrolauri',
    BAK: 'Bakuriani',
    KHAR: 'Kharagauli',
    MES: 'Mestia',
    MAN: 'Manglisi',
    URE: 'Ureki',
    STE: 'Stepantsminda',
    NEW: 'New Athos',
    CHO: 'Chokhatauri',
    SIG: 'Sighnaghi',
    ANA: 'Anaklia',
    JVA: 'Jvari',
    PAS: 'Pasanauri',
    ADI: 'Adigeni',
    KED: 'Keda',
    AKHAL: 'Akhalgori',
    LEN: 'Lentekhi',
    TSAG: 'Tsageri',
    KVAI: 'Kvaisa',
    KHU: 'Khulo',
    ABAS: 'Abastumani',
    SHU: 'Shuakhevi',
    bath: 'Bath',
    shower: 'Shower',
    notSelectType: 'Not selected',
    studio: 'Studio apartment',
    apartment1room: '1 room apartment',
    apartment2room: '2 room apartment',
    apartment3room: '3 room apartment',
    apartment4room: '4 room apartment',
    house: 'House',
    country: 'Country',
    city: 'City',
    street: 'Street',
    houseNumber: 'House number',
    typeApartment: 'Type apartment',
    address: 'Address',
    floor: 'Floor',
    square: 'Square',
    price: 'Price',
    heating: 'Central heating',
    oven: 'Oven',
    dishwasher: 'Dishwasher',
    balcony: 'Balcony',
    animal: 'Possible with animals',
    conditioner: 'Conditioner',
    microwave: 'Microwave',
    perMonth: 'per month',
    submit: 'Send',
    description: 'Description',
    priceTo: 'Price to',
    priceFrom: 'Price from',
    squareFrom: 'Square from',
    squareTo: 'Square to',
    floorFrom: 'Floor from',
    floorTo: 'Floor to',
    sell: 'Sell',
    rent: 'Rent',
    needAuth: 'To view this page, you need to log in!',
    conveniences: 'Conveniences',
    toasterErrorTitle: 'Error!',
    toasterSuccessTitle: 'Success!',
    location: 'Location',
    linkCopied: 'The link to the ad has been copied to the clipboard.',
    unableSendMessage: 'We were unable to send you a message..',
    botSentMessage: 'The bot has sent you an publication',
};

const ka = {
    GE: 'საქართველო',
    TBI: 'თბილისი',
    BAT: 'ბათუმი',
    RUS: 'რუსთავი',
    KUT: 'ქუთაისი',
    SUK: 'სოხუმი',
    GOR: 'გორი',
    POT: 'ფოთი',
    ZUG: 'ზუგდიდი',
    TSK: 'ცხინვალი',
    MAR: 'მარნეული',
    KHA: 'ხაშური',
    SAM: 'სამტრედია',
    ZES: 'ზესტაფონი',
    TEL: 'თელავი',
    KOB: 'ქობულეთი',
    AKH: 'ახალციხე',
    GAG: 'გაგრა',
    SEN: 'სენაკი',
    OZU: 'ოზურგეთი',
    GAR: 'გარდაბანი',
    KAS: 'კასპი',
    CHI: 'ჭიათურა',
    BOR: 'ბორჯომი',
    KVA: 'ყვარელი',
    SAG: 'საგარეჯო',
    BOL: 'ბოლნისი',
    TKI: 'ტყიბული',
    GUD: 'გუდაუთა',
    KHO: 'ხონი',
    GAL: 'გალი',
    CHA: 'ჩაქვი',
    AKHA: 'ახალქალაქი',
    DUS: 'დუშეთი',
    MTS: 'მცხეთა',
    GUR: 'გურჯაანი',
    TSKA: 'წყალტუბო',
    SUR: 'სურამი',
    KAR: 'ქარელი',
    LAN: 'ლანჩხუთი',
    AKHM: 'ახმეტა',
    LAG: 'ლაგოდეხი',
    KAZ: 'კაზრეთი',
    DED: 'დედოფლისწყარო',
    OCH: 'ოჩამჩირე',
    SAC: 'საჩხერე',
    TET: 'თეთრიწყარო',
    TQW: 'ტყვარჩელი',
    VAL: 'ვალე',
    TER: 'თერჯოლა',
    TSN: 'წნორი',
    ABA: 'აბაშა',
    PIT: 'ბიჭვინთა',
    MART: 'მარტვილი',
    GUL: 'გულრიფში',
    TSA: 'წალკა',
    NIN: 'ნინოწმინდა',
    TIA: 'თიანეთი',
    VAN: 'ვანი',
    DMA: 'დმანისი',
    KHOB: 'ხობი',
    TSAL: 'წალენჯიხა',
    AGA: 'აგარა',
    ZHI: 'ჟინვალი',
    ONI: 'ონი',
    ASP: 'ასპინძა',
    BAG: 'ბაღდათი',
    CHK: 'ჩხოროწყუ',
    JAV: 'ჯავა',
    SHO: 'შორაპანი',
    AMB: 'ამბროლაური',
    BAK: 'ბაკურიანი',
    KHAR: 'ხარაგაული',
    MES: 'მესტია',
    MAN: 'მანგლისი',
    URE: 'ურეკი',
    STE: 'სტეფანწმინდა',
    NEW: 'ახალი ათონი',
    CHO: 'ჩოხატაური',
    SIG: 'სიღნაღი',
    ANA: 'ანაკლია',
    JVA: 'ჯვარი',
    PAS: 'ფასანაური',
    ADI: 'ადიგენი',
    KED: 'ქედა',
    AKHAL: 'ახალგორი',
    LEN: 'ლენტეხი',
    TSAG: 'ცაგერი',
    KVAI: 'კვაისა',
    KHU: 'ხულო',
    ABAS: 'აბასთუმანი',
    SHU: 'შუახევი',
    bath: 'აბაზანა',
    shower: 'შხაპი',
    notSelectType: 'არ არის შერჩეული',
    studio: 'სტუდიო ბინა',
    apartment1room: 'სტუდიო ბინა',
    apartment2room: 'ერთოთახიანი ბინა',
    apartment3room: 'ოროთახიანი ბინა',
    apartment4room: 'ოთხოთახიანი ბინა',
    house: 'სახლი',
    country: 'ქვეყანა',
    city: 'ქალაქი',
    street: 'ქუჩა',
    houseNumber: 'სახლის ნომერი',
    typeApartment: 'ბინის ტიპი',
    address: 'მისამართი',
    floor: 'სართული',
    square: 'კვადრატი',
    price: 'ფასი',
    heating: 'ცენტრალური გათბობა',
    oven: 'ღუმელი',
    dishwasher: 'ჭურჭლის სარეცხი მანქანა',
    balcony: 'აივანი',
    animal: 'შესაძლებელია ცხოველებთან',
    conditioner: 'კონდიციონერი',
    microwave: 'ნუკი',
    perMonth: 'თვეში',
    submit: 'გაგზავნა',
    description: 'აღწერა',
    priceTo: 'ფასი არის',
    priceFrom: 'ფასი',
    squareFrom: 'ფართობი',
    squareTo: 'ფართობი',
    floorFrom: 'სართული',
    floorTo: 'სართული',
    sell: 'გაყიდვა',
    rent: 'ქირავდება',
    needAuth: 'ამ გვერდის სანახავად, თქვენ უნდა შეხვიდეთ!',
    conveniences: 'კომფორტული',
    toasterErrorTitle: 'შეცდომა!',
    toasterSuccessTitle: 'წარმატებით!',
    location: 'ადგილმდებარეობა',
    linkCopied: 'რეკლამის ბმული გადაწერილია ბუფერში.',
    unableSendMessage: 'ჩვენ ვერ გამოგიგზავნით შეტყობინებას..',
    botSentMessage: 'ბოტმა გამოგიგზავნათ შეტყობინება',
};

export const i18n = i18nFactory({ ru, en, ka });

export const currencyDesignation: Record<Currency, string> = {
    GEL: '₾',
    USD: '$',
};
